export type ContentData = {
	contentCreatorId?: string | null;
};

/**
 * Service to retrieve metadata about the current content.
 */
export class WhiteboardContentDataService {
	private contentData: ContentData = {
		contentCreatorId: null,
	};

	setContentData(contentData: ContentData) {
		this.contentData = contentData;
	}

	getContentCreatorId(): string | null | undefined {
		return this.contentData.contentCreatorId;
	}
}
